module.exports = __webpack_public_path__ + "media/images/icons/outlined/shop-8cb6c3ee5f4194e4e0d2ceafaf8cd1c0.svg";